import * as React from 'react';

import BookieSelection from './bookie-selection';

// providers
import { useServicesContext } from '~/providers/services-context';

// interfaces
import type IBookieOdds from '../interfaces/IOdds';

// styles
import styles from '../style/bookie-selector-2.module.css';

interface IProps {
  betIds: number[];
  bookies: IBookieOdds[];
  changeSelection: (bookieCode: string) => void;
  stake: number;
  selectedBookie: IBookieOdds;
}

function BookieSelector({
  betIds,
  bookies,
  changeSelection,
  stake,
  selectedBookie
}: IProps) {
  const { labelActions } = useServicesContext();

  const renderBookieSelections = () => {
    const bookiesWithIndex = React.useMemo(
      () =>
      bookies.
      map((bookie, index) => ({ ...bookie, index })).
      filter(
        (bookie) => bookie.bookmakerCode !== selectedBookie.bookmakerCode
      ),
      [bookies, selectedBookie]
    );

    const traditionalBookies = bookiesWithIndex.filter(
      (bookie) => bookie.bookmakerType === 'traditional'
    );
    const exchangeBookies = bookiesWithIndex.filter(
      (bookie) => bookie.bookmakerType === 'exchange'
    );

    const idsForClickout = Array.isArray(betIds) ? betIds : [betIds];

    return [...traditionalBookies, ...exchangeBookies].map((bookie) =>
    <BookieSelection
      key={`$bookie_selection_${bookie.bookmakerCode}`}
      betIds={idsForClickout}
      changeSelection={changeSelection}
      selection={bookie}
      stake={stake} />

    );
  };

  return (
    <div data-testid="bookie-selector" className={styles.otherBookieWrapper}>
			<div className={styles.otherBookies}>
				{labelActions.get('OTHER_BOOKIES')}:
			</div>
			{renderBookieSelections()}
		</div>);

}
export default BookieSelector;